/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentTitle = {
    properties: {
        title: {
    type: 'string',
    isRequired: true,
},
        id: {
    type: 'number',
    isRequired: true,
},
    },
};